export const tr = {
    'add-clients-success': 'todo',
    'change-status-error': 'todo {name}',
    'change-status-success': 'todo {name}'
};
